// extracted by mini-css-extract-plugin
module.exports = {"section":"_3NEb4"};